import { Case } from "interfaces/websiteContent";

export const getFilteredCases = (cases: Case[], searchTerm: string, sectors: number[]) =>
  cases
    .filter(singleCase => {
      if (searchTerm === "") {
        return singleCase;
      }
      if (singleCase.title.toLowerCase().includes(searchTerm.toLowerCase())) {
        return singleCase;
      }
      if (singleCase.description.toLowerCase().includes(searchTerm.toLowerCase())) {
        return singleCase;
      }
      return false;
    })
    .filter(singleCase => {
      if (!sectors.length) return true;
      if (singleCase.sectors === undefined) return false;
      return singleCase.sectors.some(caseSector => sectors.includes(caseSector));
    });

export const getCasebankStatusMessage = (cases: Case[]) => {
  if (cases.length) {
    return "Ingen case tilfredstiller ditt søk";
  }
  return "Ingen case er tilgjengelige for øyeblikket";
};
